import { WORKFLOW_ACTIONS, WorkflowActionInterface } from './action-definitions';
import { WORKFLOW_TRIGGERS, WorkflowTriggerInterface } from './trigger-definitions';

export const WORKFLOW_COMPONENTS: { [taskKey: string]: WorkflowTriggerInterface | WorkflowActionInterface } = {
  ...WORKFLOW_TRIGGERS,
  ...WORKFLOW_ACTIONS,
};
